import {connect} from 'react-redux';

import {gettext} from 'topmeteo/utils/i18n';
import {preventDefault} from 'topmeteo/utils/event';

import {getProduct} from 'topmeteo/general/selectors';
import {changeIndex} from 'topmeteo/base-image/actionCreators';

import Base from './Base';

const Label = gettext('Change time');

const Now = props => (
    <Base
        {...props}
        id="now"
        title={Label}
        icon="slider-up"
    />
);

const mapStateToProps = state => {
    const {resolution, columns} = getProduct(state);

    return {
        index: state.index,
        resolution,
        columns,
    };
};

const mapDispatchToProps = dispatch => ({
    onMove: (event, index, {resolution, columns, index: currentIndex}) => {
        preventDefault(event);

        const column = Math.floor(index / resolution);
        const {available} = columns[column];

        if (index === currentIndex || available === false) return;

        dispatch(changeIndex(index));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(Now);
